//React
import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";

//Libs
import { Button, Icon } from "semantic-ui-react";
import swal from "sweetalert";

//Services
import { producaov2 as api } from "../../../../../services/apis";
import { systemLogs } from "../../../../../services/system_logs";
import { useRouter } from "../../../../../hooks/router";

//Components
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";

import Loader from "../../../../../components/Loader";
import Loading from "../../../../../components/Loading";

//Styles
import {
  Container,
  Title,
  Content,
  ContainerInputSearch,
  Input,
  SemanticTable,
} from "./styles";

const ListarCursos = () => {
  const [search, setSearch] = useState("");
  const [testes, setTestes] = useState([]);
  const [page, setPage] = useState(1);
  // const [isAtivos, setIsAtivos] = useState(true);
  const [loading, setLoading] = useState(false);

  const [idLicao, setIdLicao] = useState(null);

  const router = useRouter();

  useEffect(() => {
    const { id_licao } = router.query;

    setIdLicao(id_licao);
  }, [router]);

  useEffect(() => {
    loadTestes(1);
  }, []);

  const loadTestes = useCallback(
    async (page) => {
      setLoading(true);

      try {
        const params = {
          search,
          page,
        };

        const response = await api.get("testes/list", { params });

        setTestes(response.data.testes);
        await systemLogs("testes/", "listou os testes");
        setLoading(false);
      } catch (err) {
        swal("Não foi possível carregar os testes", err, "error");
        setLoading(false);
      }
    },
    [search]
  );

  const addPage = useCallback(async () => {
    const newPage = page + 1;

    setPage(newPage);
    await loadTestes(newPage);
  }, [page]);

  const removePage = useCallback(async () => {
    if (page <= 1) {
      return;
    }

    const newPage = page - 1;

    setPage(newPage);
    await loadTestes(newPage);
  }, [page]);

  const doSearch = useCallback(() => {
    loadTestes(page);
  }, [page, loadTestes]);

  const associateLicao = useCallback(
    async (index) => {
      try {
        const teste = testes[index];

        await api.put(`testes/${teste.id}/associate-licao/${idLicao}`);

        swal("Teste salvo !", "Teste atribuído com sucesso.", "success");
      } catch (err) {
        console.error(err);
        swal("Erro !", "Houve um problema a atribuir teste a lição", "error");
      }
    },
    [testes, idLicao]
  );

  return (
    <Container>
      <AdminMenu />
      <Content>
        <Title>Testes</Title>

        <ContainerInputSearch>
          <Input
            type="text"
            placeholder="Pesquise pelo titulo"
            onChange={(e) => setSearch(e.target.value)}
            onKeyUp={(e) => e.key === "Enter" && doSearch()}
          />
          <Link>
            <Button onClick={doSearch}>
              <Icon name="search" />
            </Button>
          </Link>

          <Link to="/admin/ead/testes/criar">
            <Button>Criar</Button>
          </Link>
        </ContainerInputSearch>

        <SemanticTable size="big" celled>
          <SemanticTable.Header>
            <SemanticTable.Row>
              <SemanticTable.HeaderCell>Id</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Titulo</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Js ID</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
            </SemanticTable.Row>
          </SemanticTable.Header>

          <SemanticTable.Body className="table-body">
            {loading ? (
              <Loading
                msg={
                  !search ? "Buscando testes..." : `Buscando por ${search}...`
                }
              />
            ) : (
              testes.map((teste, index) => (
                <SemanticTable.Row>
                  <SemanticTable.Cell>{teste.id}</SemanticTable.Cell>
                  <SemanticTable.Cell>{teste.titulo}</SemanticTable.Cell>
                  <SemanticTable.Cell>{teste.js_id}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <>
                      <Button
                        title="Ir para página de edição de teste"
                        icon="edit icon"
                        size="small"
                        color={"grey"}
                        onClick={() =>
                          window.open(`/admin/ead/testes/${teste.id}`)
                        }
                      />
                      {idLicao && (
                        <Button
                          title={`Atribuir teste a lição (${idLicao})`}
                          icon="thumb tack icon"
                          size="small"
                          color={"grey"}
                          onClick={() => associateLicao(index)}
                        />
                      )}
                    </>
                  </SemanticTable.Cell>
                </SemanticTable.Row>
              ))
            )}
          </SemanticTable.Body>
        </SemanticTable>
        {page > 1 && (
          <Button floated="left" onClick={removePage}>
            Voltar
          </Button>
        )}

        <Button floated="right" onClick={addPage}>
          Avançar
        </Button>
      </Content>
    </Container>
  );
};

export default ListarCursos;
